/**
 * Created by jlamy on 2/8/2018
 */
angular.module('comcast.common.communication').factory('DestinationTypeResourceFactory', ['$resource', 'EndPointService', 'NotificationInterceptor', function ($resource, ResourceEndPointService, NotificationInterceptor) {
  'use strict';

  return $resource(ResourceEndPointService.destinationTypeEndPoint + '/:id', {
    id: '@id'
  }, {
    save: {
      method: 'POST',
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('destination types').setAction('Saving')
    },
    getAll: {
      method: 'GET',
      isArray: true,
      interceptor: new NotificationInterceptor().setObject('destination types').setAction('Retrieving'),
      cancellable: true
    }
  });
}]);